<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>
		<Content class="app-content__main">
			<TableFuncs>
				<Button type="primary" icon="ios-add-circle-outline" @click="addShow">新增banner</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addStoreShow" :title="addForm.id?'编辑banner':'新增banner'">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">
				<FormItem label="所属app:" prop="fromApp">
					<Select v-model="addForm.fromApp" clearable style="width: 100%;">
						<Option v-for="item in apps" :value="item.id" :key="item.id">{{ item.name }}</Option>
					</Select>
				</FormItem>
				<FormItem label="banner名称" prop="bannerName">
					<Input v-model="addForm.bannerName" placeholder="填写banner名称"></Input>
				</FormItem>
				<FormItem label="banner图片" prop="bannerImg">
					<Upload :action="uploadFile" name="file" :on-success="uploadCallback" :default-file-list="fileList"
						:data="uploadData" accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传文件</Button>
					</Upload>
				</FormItem>
				<FormItem label="链接类型" prop="bannerType">
					<RadioGroup v-model="addForm.bannerType">
						<Radio label="1">应用内页面</Radio>
						<Radio label="2">h5链接</Radio>
						<Radio label="3">第三方小程序</Radio>
						<Radio label="4">图片</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="跳转链接" prop="link">
					<Input v-model="addForm.link" placeholder="填写跳转链接"></Input>
				</FormItem>
				<FormItem label="状态" prop="status">
					<i-switch v-model="addForm.status=='1'" size="large"  @on-change="changeStatus($event,item)">
						<span slot="open">启用</span>
						<span slot="close">停用</span>
					</i-switch>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateData">确认提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition'
	import TableFuncs from '../../components/statistics/TableFuncs'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				apps: [{
					id: '1',
					name: '应届生直聘'
				}],
				uploadFile: api.statistics.uploadFile,
				fileList: [],
				uploadData: {
					filePath: 'img'
				},
				loading: false,
				queryData: [],
				storeList: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addStoreShow: false,
				addForm: {
					fromApp: undefined,
					bannerName: undefined,
					bannerImg: undefined,
					bannerType: undefined,
					link: undefined,
					status: '1'
				},
				addRule: {
					fromApp: [{
						required: true,
						message: '请选择所属app',
						trigger: 'blur',
					}],
					bannerName: [{
						required: true,
						message: '请选择填写banner名称',
						trigger: 'blur'
					}],
					bannerImg: [{
						required: true,
						message: '请上次banner图片',
						trigger: 'blur'
					}],
					bannerType: [{
						required: true,
						message: '请选择banner类型类型',
						trigger: 'blur'
					}],

				}
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '归属app',
						align: 'center',
						render: (h, params) => {
							let name;
							let val = params.row.fromApp;
							if (val == '1') {
								name = '兼职直聘'
							}
							return h('span', name)
						}
					},
					{
						title: '名称',
						key: 'bannerName',
						align: 'center'
					},
					{
						title: '图片',
						key: 'bannerImg',
						align: 'center'
					},
					{
						title: '类型',
						align: 'center',
						render: (h, params) => {
							let name;
							let val = params.row.bannerType;
							if (val == '1') {
								name = '应用内页面'
							} else if (val == '2') {
								name = 'h5链接'
							} else if (val == '3') {
								name = '第三方小程序'
							} else if (val == '4') {
								name = '图片'
							}

							return h('span', name)
						}
					},
					{
						title: '跳转链接',
						key: 'link',
						align: 'center',
					},
					{
						title: '跳转链接',
						align: 'center',
						render: (h, params) => {
							let name;
							let val = params.row.status;
							if (val == '1') {
								name = '启用'
							} else {
								name = '停用'
							}

							return h('span', name)
						}
					},
					{
						title: '日期',
						key: 'createTime',
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}

				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			getData() {
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize
				}
				api.statistics
					.bannerPage(queryParams)
					.then(res => {
						const result = res.data || {}
						this.totalRecord = result.totalRecordNum || 0
						this.queryData = result.records
					})
					.catch(err => {
						this.$Message.error('获取数据失败: ' + err.message)
					})
					.then(() => {
						this.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			addOrUpdateData() {
				const that = this
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						let params = {
							...that.addForm
						}
						api.statistics
							.addOrEditBanner(params)
							.then(res => {
								that.$Message.success('Success!');
								that.refreshData()
								that.addStoreShow = false
							})
							.catch(err => {})

					}
				})
			},
			delData(id) {
				const that = this
				that.$Modal.confirm({
					title: '操作确认',
					content: '数据删除不可恢复，确定删除吗？',
					onOk: function() {
						api.statistics
							.delDayPic({
								'id': id
							})
							.then(res => {
								that.$Message.success('Success!');
								that.refreshData()
							})
					}
				})

			},

			addShow() {
				this.addForm = {
					fromApp: undefined,
					bannerName: undefined,
					bannerImg: undefined,
					bannerType: undefined,
					link: undefined,
					status: '1'
				}
				this.fileList = []
				this.addStoreShow = true
			},
			editData(rowData) {
				this.addForm = {
					id: rowData.id,
					fromApp: rowData.fromApp,
					bannerName: rowData.bannerName,
					bannerImg: rowData.bannerImg,
					bannerType: rowData.bannerType,
					link: rowData.link,
					status: rowData.status,
				}
				this.fileList = [{
					name: rowData.bannerName,
					url: rowData.bannerImg
				}]
				this.addStoreShow = true

			},
			uploadCallback(response, file, fileList) {
				this.addForm.picUrl = response.data.url
				this.addForm.bannerImg = response.data.fileName,
					this.fileList = [{
						name: response.data.fileName,
						url: response.data.url
					}]
			},
			changeStatus(state, data) {
				this.addForm.status = state ? '1' : '0'
			},
		},



	}
</script>